import { useState } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { useGetServiceRequest } from "../../api/queries/useGetServiceRequest";

import PageContentWrapper from "./PageContentWrapper";
import ServiceRequestHeader from "./ServiceRequestHeader";
import ServiceRequestSummary from "./ServiceRequestSummary";

const ServiceRequestPage = () => {
  const { serviceRequestId } = useParams();
  const { data: serviceRequest, isLoading: isServiceRequestLoading } = useGetServiceRequest(Number(serviceRequestId));

  const [isContractPaid, setIsContractPaid] = useState(false);
  const handleSetIsContractPaid = (isContractPaid: boolean) => setIsContractPaid(isContractPaid);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.serviceDetailsContainer}>
        <ServiceRequestHeader serviceId={serviceRequest?.service.id} serviceName={serviceRequest?.service.name} />
        <PageContentWrapper
          serviceRequest={serviceRequest}
          isServiceRequestLoading={isServiceRequestLoading}
          handleSetIsContractPaid={handleSetIsContractPaid}
        />
      </Box>
      <ServiceRequestSummary
        serviceRequest={serviceRequest}
        isLoading={isServiceRequestLoading}
        isContractPaid={isContractPaid}
      />
    </Box>
  );
};

export default ServiceRequestPage;

const styles = {
  container: {
    position: "relative",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: "16px",
  },
  serviceDetailsContainer: {
    width: { xs: "100%", lg: "553px" },
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
};
